<template>
    <field-wrapper
        id="customerEmailConfirm"
        :label-text="texts.label"
        :error-text="errorMessage"
        :show-error="Boolean(errorMessage)"
    >
        <input-text
            id="customerEmailConfirm_input"
            v-model="value"
            type="email"
            autocomplete="email"
            aria-describedby="customerEmailConfirm_error"
            :aria-invalid="errorMessage ? 'true' : 'false'"
        />
    </field-wrapper>
</template>

<script>
import FieldWrapper from "@/components/elements/FieldWrapper";
import InputText from "@/components/inputs/InputText";

import { mapGetters, mapMutations } from "vuex";

export default {
    components: {
        FieldWrapper,
        InputText
    },
    props: {
        validate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        texts() {
            return {
                ...this.$t("field_customer_email"),
                ...this.$t("field_customer_email_confirm")
            };
        },
        value: {
            get() {
                return this.emailConfirm || "";
            },
            set(emailConfirm) {
                this.updateCustomer({ emailConfirm });
            }
        },
        errorMessage() {
            if (this.validate && this.error) return this.texts[this.error];
            return null;
        },
        ...mapGetters({
            emailConfirm: "customer/getEmailConfirm",
            error: "customer/getEmailConfirmError"
        })
    },
    methods: {
        ...mapMutations({
            updateCustomer: "customer/updateCustomer"
        })
    }
};
</script>
